var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"title":"About"}}),_vm._v(" "),_c('AboutThree'),_vm._v(" "),_c('Promotion'),_vm._v(" "),_c('ServicesTwo'),_vm._v(" "),_c('div',{staticClass:"section_border"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }